export default {
    cart: state =>  state.cart.items,
    total: (state) => {
        var res = 0
        _.map(state.cart.items, (item) => {
          res += parseFloat(item.subTotal)
        })
        return res.toFixed(2)
    },
    servicesTotal: (state) => {
        var res = 0
        var res_options = 0
        let total = 0
        _.map(state.cart.items, (item) => {
          res += parseFloat(item.subTotal)
            _.map(item.options, (opt) => {            
                res_options += opt.subTotal ? parseFloat(opt.subTotal) : 0
            })            
        })
        total = res + res_options
        return total.toFixed(2)
    },    
    order: (state) => {
        var order = []
        _.map(state.cart.items, (item) => {
            order.push({ poid: item.oid, qty: item.pieces })
        })
        return order
    }, 
    servicesOrder: (state) => {
        var order = []
        var options = []
        _.map(state.cart.items, (item) => {
            _.map(item.options, (opt) => {
                options.push({ eoid: opt.eoid, soid: opt.oid, qty: opt.number })
            })
            order.push({ eoid: item.eoid, soid: item.oid_server, qty: item.pieces, options: options })
        })
        return order
    },     
    itemsNumber: (state) => {
        return state.cart.items.length
    },        
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/cart/getters.js
// module id = null
// module chunks = 